import { formatCurrencyFromCents, maskEmail } from "@simplyk/common";
import { ToolUIPart } from "ai";

import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { trpc } from "@/common/helpers/trpc";
import { useTranslate } from "@/common/hooks/useTranslate";

const getTransactionId = (part: ToolUIPart): string | null =>
  typeof part.input === "object" &&
  part.input !== null &&
  "transactionId" in part.input &&
  typeof part.input.transactionId === "string"
    ? part.input.transactionId
    : null;

export const useApprovalDescription = (part: ToolUIPart): string => {
  const { t } = useTranslate();
  const { locale, isoLocale } = useLocaleContext();
  const transactionId = part.type === "tool-resendConfirmation" ? getTransactionId(part) : null;
  const { data: payment } = trpc.retrieveDonorDashboardTransaction.useQuery(
    { id: transactionId ?? "" },
    { enabled: Boolean(transactionId) }
  );

  if (part.type === "tool-requestHumanSupport") {
    return t("dashboard", "donorAssistant.approval.requestHumanSupport");
  }
  const organizationName = payment?.organization?.name;
  if (!payment?.email || !organizationName) {
    return t("dashboard", "donorAssistant.approval.resendConfirmationFallback");
  }
  const date = new Date(payment.createdAtUtc).toLocaleDateString(locale, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const amount = formatCurrencyFromCents(payment.transferrableAmount, { isoLocale, currency: payment.currency });
  return t("dashboard", "donorAssistant.approval.resendConfirmation", {
    payment: `${date} · ${organizationName} · ${amount}`,
    email: maskEmail(payment.email),
  });
};
